// extracted by mini-css-extract-plugin
export default {"toggle__blocks":"toggle-blocks_toggle__blocks__Qv55i","buttons":"toggle-blocks_buttons__6QbeU","active":"toggle-blocks_active__Qb-TH","toggled":"toggle-blocks_toggled__LJlg8"};